import {
  aDeleteRuleTuningExpression,
  mockDeleteRuleTuningExpressionOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockDeleteRuleTuningExpressionOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          deleteRuleTuningExpression: aDeleteRuleTuningExpression(),
        },
      });
    }
  ),
];
